//#region src/framework/utils/constants.ts
const unicode = {
	BULLET: "•",
	COPYRIGHT: "©",
	DAGGER: "†",
	DEGREE_C: "℃",
	DEGREE_F: "℉",
	DOUBLE_DAGGER: "‡",
	REGISTERED: "®",
	SECTION: "§",
	TRADEMARK: "™"
};

//#endregion
export { unicode };